/* My Acre — brighter In Stock dot (2026-07-17).
   Injects one small CSS override, brightening the genuine "In Stock" dot
   (.product__highilight--stock-in .product__highilight-dot, rendered by
   snippets/product.liquid from real inventory data for every vendor) from
   the theme default sage #7C8F6E to #2FB84D, on any page with a PDP buy box.
   This is a general, site-wide cosmetic preference — it is not specific to
   any single product or promotion, so it has been kept.

   Rev 20 Jul 2026 (Claude): this file used to also carry the free e-NRG fuel
   offer for EcoSmart Fire Pits. All of that has now been removed at the site
   owner's request:
     - the "2 free cartons of e-NRG fuel" promo card under the price
       (injectStrip/.ma-fuelperk) — removed earlier the same day.
     - the auto-add-to-cart of the fuel line item whenever a qualifying fire
       was added to cart (ensureFuel/addFuel/wireAutoAdd/fuelInCart/
       currentFireVariantId/fireInCart, plus the FUEL_VARIANT_ID constant they
       used) — removed. Fuel is never silently added to a customer's cart; if
       they want it, they add it themselves like any other accessory.
     - the "free"/struck-through price treatment and the locked "Included"
       pill (CHECK svg + .ma-ob__added) that replaced the Add button on the
       fuel row inside the "commonly bought with" cross-sell
       (transformFuelRow/.ma-ob__row--free) — removed. That row now falls
       through to the same default rendering as every other accessory in the
       list (real price, working Add button).

   Set OFFER_LIVE to false (or remove the include in
   snippets/vital-loader.liquid) to switch the dot-color override off too. */
(function () {
  var OFFER_LIVE = true;

  if (!OFFER_LIVE) return;

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function injectStyles() {
    if (document.getElementById('ma-fuel-css')) return;
    var css = [
      `.product__highilight--stock-in .product__highilight-dot{background:#2FB84D !important;}`
    ].join('');
    var s = document.createElement('style');
    s.id = 'ma-fuel-css';
    s.textContent = css;
    document.head.appendChild(s);
  }

  ready(function () {
    var buybox = document.querySelector('.ma-buybox');
    if (!buybox) return;
    if (window.location.pathname.indexOf('/products/') === -1) return;
    injectStyles();
  });
})();
